module.exports = __webpack_public_path__ + "img/anna.0e014a6e.png";